export const AboutImage = () => {
  return (
    <div className="col-xs-12 col-md-6">
      <img src="img/bismillah.webp" className="img-responsive" alt="Bismillah" />
    </div>
  );
};
